// extracted by mini-css-extract-plugin
export default {"container":"z3imsvv-w5","name":"_2yiAaicgC0","image":"kcaINXGWzp","info":"aAko5S10um","info-item":"f-5dNvAE2C","infoItem":"f-5dNvAE2C","description":"X1Hpv4Aq-P","links":"XhHZ8kN3qk"};
    if(module.hot) {
      // 1643570506110
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  